import classNames from 'classnames/bind';
import React from 'react';
import {
  ICarbonEmissionAverage,
  getRoundCarbonEmissionInfo,
} from 'common/emissions';
import { IGroupedPromotion } from 'common/promotion';
import { IKeyStringValue } from 'common/types';
import { getDepartureArrivalHighlight, getStopCount } from 'common/utils';
import { ScheduleType, SearchType } from 'contexts/searchParams';
import Route from 'list/common/route';
import ItemHeader from '../item/header';
import { IScheduleDetail, ScheduleKeys } from '../types';
import { toDays } from '../utils';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const RoundDiffAL = ({
  schedule,
  airlines,
  otherItems,
  sch,
  journeyTimes,
  fareType,
  promotion,
  isDirectPromotion,
  carbonEmissionAverages,
  className,
  airports,
  showHelpTooltip,
}: {
  schedule: IScheduleDetail[][];
  airlines: IKeyStringValue;
  otherItems: string[];
  sch: string;
  journeyTimes: string[][];
  fareType: string;
  promotion?: IGroupedPromotion;
  isDirectPromotion?: boolean;
  carbonEmissionAverages: ICarbonEmissionAverage;
  className?: string;
  airports: IKeyStringValue;
  showHelpTooltip?: boolean;
}) => {
  const { carbonEmissionAverage, carbonEmission } = getRoundCarbonEmissionInfo({
    schedule,
    carbonEmissionAverages,
  });

  return (
    <>
      {schedule.map((scheduleDetail, i) => {
        const { sdt, sa } = scheduleDetail[0];
        const { edt, ea } = scheduleDetail[scheduleDetail.length - 1];
        const sdtDay = toDays(sdt);
        const edtDay = toDays(edt);
        const dayDiff = edtDay.startOf('d').diff(sdtDay.startOf('d'), 'd');

        const avs = Array.from(
          new Set(scheduleDetail.map(s => s[ScheduleKeys.airlineVendor])),
        );
        const stops = getStopCount(scheduleDetail);

        const oavs = Array.from(
          new Set(scheduleDetail.filter(s => s.oav).map(s => s.oav)),
        );
        const { departureHighlight, arrivalHighlight } =
          getDepartureArrivalHighlight({ schedule, index: i });

        return (
          <div key={`diffAl_${i}`} className={cx('RoundDiffAL', className)}>
            <ItemHeader
              avs={avs}
              oavs={oavs}
              airlines={airlines}
              otherItems={i === 0 ? otherItems : []}
              sch={sch}
              fareType={fareType}
              promotion={i === 0 ? promotion : undefined}
              isDirectPromotion={i === 0 ? isDirectPromotion : false}
              carbonEmission={carbonEmission}
              carbonEmissionAverage={carbonEmissionAverage}
            />
            <Route
              departureTime={sdtDay.format('HH:mm')}
              arrivalTime={edtDay.format('HH:mm')}
              departureCity={sa}
              arrivalCity={ea}
              dayDiff={dayDiff}
              stop={stops}
              searchType={SearchType.INTERNATIONAL}
              journeyTime={journeyTimes[i]}
              schedule={scheduleDetail}
              departureHighlight={departureHighlight}
              arrivalHighlight={arrivalHighlight}
              isList
              scheduleType={!!i ? ScheduleType.ARRIVAL : ScheduleType.DEPARTURE}
              airlines={airlines}
              airports={airports}
              showHelpTooltip={showHelpTooltip && !i}
            />
          </div>
        );
      })}
    </>
  );
};

export default RoundDiffAL;
